<template>
	<div class="test" v-if="pageTest.elements">


		<section class="main-content" v-in-viewport="">
			<div class="inside">
				<h1 class="main-title">{{pageTest.elements.headline.value}}</h1>
				<div class="description" v-html="pageTest.elements.content.value">
				</div>
			</div>
		</section>







<div class="clearfix"></div>

<section class="contact-section">
	<div class="inside">
		<div class="row">
			<div class="copy col-xs-12 col-md-6 col-lg-8" >
				<h3>About Marcus Thomas LLC</h3>
				<p>Marcus Thomas LLC, with 300 professionals in its offices in Cleveland and Cincinnati, Ohio, Buenos Aires, Argentina and Santiago, Chile, is among America’s leading independent advertising agencies. Marcus Thomas is a recognized leader in digital strategy and technology; is Ohio’s largest media planning and buying agency; has been recognized by the Content Marketing Institute as one of the world’s leading content marketing agencies; and is regularly honored for its award-winning creative and social media campaigns.</p>
				<router-link to="/solutions" tag="button" class="btn_orange">CAPABILITIES</router-link>
			</div>

			<div class="image col-xs-12 col-md-6 col-lg-4">
				<img src="dist/about.png" alt="" class="o-fit">
			</div>

		</div>
	</div>
</section>

</div>
</template>


<script>
	import apiConnection from '../mixins/apiConnection.js';
	import seoModule from '../mixins/seoModule.js';


	var objectFitImages = require('object-fit-images');
	import Footer from '../layout/footer-component.vue';


	require('../assets/img/about.png');

	export default{
		name:'Test',
		data () {
			return {
				pageTest: [],
				modularContent:[],

			}
		},
		created:function(){
			//document.body.classList.add("healtcare");
			this.getTest();


		},
		mounted: function() {
			setTimeout(function(){
				$('.st-sticky-share-buttons').removeClass('st-sticky-share-buttons-show')
			},500);
		},
		computed: {
			version: function(){
				return 'v2';
			}
		},
		components:{
			'Footer':Footer,
		},
		mixins:[apiConnection,seoModule]
	}
</script>



// WEBPACK FOOTER //
// Test.vue?44a92f7f